import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import { ReactComponent as CopyLinkIcon } from 'assets/copy-link.svg';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from 'components/shared/CustomAlert/CustomAlertContain';
import CustomPopOver from 'components/shared/CustomPopOver/CustomPopOver';
import React, { useState } from 'react';
import zeplinColor from 'theme/Color';

const ContactCard = ({ data, loading }: { data: any; loading: boolean }) => {
  const theme = useTheme();
  const details = data;
  const [contactAnchorEl, setContactAnchorEl] = useState<HTMLDivElement | null>(null);
  const openContact = Boolean(contactAnchorEl);
  const idContact = openContact ? 'simple-popover' : undefined;
  const [emailLink, setEmailLink] = useState('');
  const [phone, setPhone] = useState('');
  const [copy, setCopy] = useState('');
  const handleCopyLink = (val: any, type: string) => {
    navigator.clipboard.writeText(val);
    setCopy(`${type} copied`);
  };
  const handleClose = () => {
    setCopy('');
  };
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    event.stopPropagation();
    setContactAnchorEl(event.currentTarget);
  };
  return (
    <Box
      sx={{
        borderRadius: '14px',
        backgroundColor: zeplinColor.Neutral3,
        padding: '12px',
        display: 'flex',
        gap: '12px',
        flex: 1,
      }}
    >
      {loading ? (
        <Skeleton
          variant='rounded'
          width={'56px'}
          height={56}
          sx={{ backgroundColor: zeplinColor.Neutral4 }}
        />
      ) : (
        <img
          src={details?.picture || ''}
          alt='logo'
          loading='lazy'
          style={{ objectFit: 'fill', borderRadius: '14px', width: '56px', height: '56px' }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = '/assets/profile.svg';
          }}
        />
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '100%',
                backgroundColor: zeplinColor.Neutral4,
              }}
            />
          ) : (
            <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              {' '}
              <Typography variant='responsiveBody2'>
                {details?.firstName} {details?.lastName}
              </Typography>
              <img
                src={'/assets/linkedin-link.svg'}
                alt='logo'
                loading='lazy'
                style={{ objectFit: 'fill', width: '18px', height: '18px' }}
              />
            </Box>
          )}
        </Box>
        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              width: '100%',
              backgroundColor: zeplinColor.Neutral4,
            }}
          />
        ) : (
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            {data?.jobTitle || 'NA'}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {loading ? (
            <Skeleton
              variant='rounded'
              width={'20px'}
              height={'20px'}
              sx={{ backgroundColor: zeplinColor.Neutral4 }}
            />
          ) : data?.email ? (
            <img
              onClick={(e: any) => {
                handleClick(e);
                setPhone('');
                setEmailLink(data?.email);
              }}
              src={'/assets/zoominfo-mail.svg'}
              alt='logo'
              loading='lazy'
              style={{ objectFit: 'fill', width: '20px', height: '20px' }}
            />
          ) : (
            ''
          )}
          {loading ? (
            <Skeleton
              variant='rounded'
              width={'20px'}
              height={'20px'}
              sx={{ backgroundColor: zeplinColor.Neutral4 }}
            />
          ) : data?.mobilePhone ? (
            <img
              onClick={(e: any) => {
                handleClick(e);
                setEmailLink('');

                setPhone(data?.mobilePhone);
              }}
              src={'/assets/zoominfo-call.svg'}
              alt='logo'
              loading='lazy'
              style={{ objectFit: 'fill', width: '20px', height: '20px' }}
            />
          ) : (
            ''
          )}
        </Box>
      </Box>
      <CustomPopOver
        onClick={(e: any) => {
          e.stopPropagation();
        }}
        setAnchorEl={setContactAnchorEl}
        anchorEl={contactAnchorEl}
        id={idContact}
        sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            padding: '16px',
          }}
        >
          <Box
            sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              handleCopyLink(phone ? phone : emailLink, phone ? 'Phone' : 'Email');
              setContactAnchorEl(null);
            }}
          >
            <CopyLinkIcon width={18} height={18} />
            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              Copy
            </Typography>
          </Box>
          {emailLink && (
            <a
              href={`mailto:${emailLink}`}
              onClick={(e) => {
                e.stopPropagation();
                setContactAnchorEl(null);
              }}
              target='_blank'
              rel='noopener noreferrer'
              style={{ textDecoration: 'none' }}
            >
              <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
                <img
                  src={'/assets/zoominfo-mail.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{ objectFit: 'fill', width: '18px', height: '18px' }}
                />
                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  Email
                </Typography>
              </Box>
            </a>
          )}
        </Box>
      </CustomPopOver>

      <CustomAlert
        open={copy ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={copy}
            alertIcon={<img src='/assets/checkmark-green.png' width={24} height={24} />}
            error={false}
          />
        }
        error={false}
      />
    </Box>
  );
};

export default ContactCard;
